import { withSubComponent } from '@magnetic/higher-order-components';
import { AddableTag } from './addable/index.js';
import { BinaryTag } from './binary/index.js';
import { ColoredTag } from './colored/index.js';
import { TagGroup } from './group/index.js';
import { SelectableTag } from './selectable/index.js';
import { StatusTag } from './status/index.js';
import { Tag as Tag$1 } from './tag.js';
import '@magnetic/theme';

const Tag = withSubComponent(Tag$1, {
  Colored: ColoredTag,
  Group: TagGroup,
  Status: StatusTag,
  Selectable: SelectableTag,
  Binary: BinaryTag,
  Addable: AddableTag
});

export { Tag };
//# sourceMappingURL=index.js.map
